import client from '../axios';
import { GET_SHOPPING_PRODUCT, GET_SHOPPING_PRODUCT_DETAIL, PUT_SHOPPING_BOOK_PRODUCT, GET_SHOPPING_BOOK_BOOK_CATEGORY, PUT_SHOPPING_BOOK_SORT, POST_SHOPPING_BOOK_PRODUCT, GET_SHOPPING_BOOK_PRODUCT_DETAIL, POST_SHOPPING_PRODUCT, PUT_SHOPPING_PRODUCT, DELETE_SHOPPING_PRODUCT, GET_SHOPPING_PRODUCT_CATEGORY, POST_SHOPPING_PRODUCT_CATEGORY, PUT_SHOPPING_PRODUCT_CATEGORY, DELETE_SHOPPING_PRODUCT_CATEGORY, PUT_SHOPPING_PRODUCT_SALE_STATUS, GET_SHOPPING_BOOK_CLASS, GET_SHOPPING_BOOK_CLASS_INVENTORY, PUT_PRODUCT, GET_SHOPPING_PRODUCT_ORDER_DETAIL, DELETE_SHOPPING_BOOK } from './endpoint';

//교재등록
export const postBookProductAPI = (params) => {
  return client.post(POST_SHOPPING_BOOK_PRODUCT, params);
};

//교재수정
export const putBookProductAPI = (params) => {
  return client.put(PUT_SHOPPING_BOOK_PRODUCT, params);
};

//교재상세
export const getBookProductDetailAPI = (idx) => {
  return client.get(GET_SHOPPING_BOOK_PRODUCT_DETAIL.replace(':idx', idx));
};

//물품 카테고리 수정
export const putShoppingBookAPI = (params) => {
  return client.put(PUT_SHOPPING_BOOK_PRODUCT, params);
};

//교재카테고리트리 목록
export const getShoppingBookTreeCategoryAPI = () => {
  return client.get(GET_SHOPPING_BOOK_BOOK_CATEGORY);
};

//교재 순서 변경
export const putShoppingBookSortAPI = (params) => {
  return client.put(PUT_SHOPPING_BOOK_SORT, params);
};

// 교재 삭제(일괄)
export const deleteShoppingBookAPI = (params) => {
  return client.delete(DELETE_SHOPPING_BOOK, { data: params });
};

//물품등록
export const postProductAPI = (params) => {
  return client.post(POST_SHOPPING_PRODUCT, params);
};

//물품수정
export const putShoppingProductAPI = (params) => {
  return client.put(PUT_PRODUCT, params);
};

//물품목록
export const getProductListAPI = (params) => {
  return client.get(GET_SHOPPING_PRODUCT, { params });
};

//물품상세
export const getProductDetailAPI = (idx) => {
  return client.get(GET_SHOPPING_PRODUCT_DETAIL.replace(':idx', idx));
};

//물품상세 - 교육원
export const getProductOrderDetailAPI = (idx) => {
  return client.get(GET_SHOPPING_PRODUCT_ORDER_DETAIL.replace(':idx', idx));
};

//물품 판매상태수정 (일괄수정)
export const putProductAPI = (params) => {
  return client.put(PUT_SHOPPING_PRODUCT, params);
};

//물품 삭제 (일괄삭제)
export const deleteProductAPI = (params) => {
  return client.delete(DELETE_SHOPPING_PRODUCT, { data: params });
};

//물품 카테고리 조회
export const getShoppingProductCategoryAPI = () => {
  return client.get(GET_SHOPPING_PRODUCT_CATEGORY);
};

//물품 카테고리 추가/수정
export const postShoppingProductCategoryAPI = (params) => {
  return client.post(POST_SHOPPING_PRODUCT_CATEGORY, params);
};

//물품 카테고리 수정
export const putShoppingProductCategoryAPI = (params) => {
  return client.put(PUT_SHOPPING_PRODUCT_CATEGORY, params);
};

//물품 카테고리 삭제
export const deleteShoppingProductCategoryAPI = (idx) => {
  return client.delete(DELETE_SHOPPING_PRODUCT_CATEGORY.replace(':idx', idx));
};

// 물품 카테고리 처리 결과 일괄 상태 변경
export const putShoppingProductSaleStatus = (params) => {
  return client.put(PUT_SHOPPING_PRODUCT_SALE_STATUS, params);
};

// 분류별 교재 목록
export const getShoppingBookClassAPI = (idx) => {
  return client.get(GET_SHOPPING_BOOK_CLASS.replace(':idx', idx));
};
// 분류별 교재(재고 있는것만) 목록
export const getShoppingBookClassInventoryAPI = (idx) => {
  return client.get(GET_SHOPPING_BOOK_CLASS_INVENTORY.replace(':idx', idx));
};
